<template>
  <!-- Navigation bar -->
  <nav class="navbar is-white">
    <div class="navbar-brand">
      <a href="/" class="navbar-item">
        <figure class="websiteLogo" v-if="loadLogo">
          <img :src="loadLogo" alt="image" style="max-height: 50px; min-width: 200px;">
        </figure>
      {{ loadLogo ? null : 'TheAdmin' }}
      </a>
      <div @click="openNavMobile = !openNavMobile" :class="{'is-active': openNavMobile}" class="navbar-burger burger" data-target="navbarExampleTransparentExample">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div class="navbar-menu" :class="{'is-active': openNavMobile}">
      <div class="navbar-end">
        <li v-for="(link, index) in nav" :key="index" class="navbar-item" :class="{'has-dropdown, is-hoverable': link.children}">
          <a v-if="link.isAbsolute" :class="{'navbar-link': link.children}" @click="toggleNav" :href="link.path" target="_blank">{{link.name}} <i v-if="link.children" class="fa"></i></a>
          <router-link v-else :class="{'navbar-link': link.children}" @click.native="toggleNav" :to="link.path">{{link.name}} <i v-if="link.children" class="fa"></i></router-link>

          <div class="navbar-dropdown" v-if="link.children">
            <span v-for="(subLink, index) in link.children" :key="index">
              <a v-if="subLink.isAbsolute" class="navbar-item" :href="subLink.path" target="_blank">
                {{subLink.name}}
              </a>
              <router-link class="navbar-item" v-else :to="subLink.path">{{subLink.name}}</router-link>
            </span>
          </div>
        </li>
        <li v-for="(social, socialKey) in socials" :key="socialKey" class="navbar-item">
          <ul class="sub-nav">
            <li>
              <a :href="social.url" target="_blank"><i :class="'fa fa-'+social.icon"></i></a>
            </li>
          </ul>
        </li>
      </div>
    </div>
  </nav>
</template>

<script>
import { navRef, mediaRef, contentsRef, routesRef } from '@/admin/firebase_config'
import contentFetch from '@/admin/mixins/contentFetch'

export default {
  name: 'app-nav',
  mixins: [contentFetch],
  firebase: {
    // load settings as object instead of array (default)
    nav: {
      source: navRef
    },
    media: {
      source: mediaRef
    },
    routes: routesRef,
    contents: contentsRef
  },
  computed: {
    loadLogo () {
      var i = this.media.length
      var url = null
      while (i--) {
        if (this.media[i].name === 'WebsiteLogo') {
          url = this.media[i].src
        }
      }
      return url
    },
    socials () {
      return this.getContentsByType('Socials')
    }
  },
  data () {
    return {
      openNavMobile: false
    }
  },
  methods: {
    toggleNav (event) {
      const targetElement = event.target.parentElement.parentElement
      if (targetElement.nodeName === 'LI') {
        targetElement.className = targetElement.className === 'open' ? '' : 'open'
      }

      event.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';
.is-white{
  background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) !important;
}
@media screen and (max-width: 1087px){
  a.navbar-link{
    padding-right: 12px;
  }
  .navbar-dropdown{
    padding-top: 0;
    padding-bottom: 0;
    background-color: #f6f6f6 !important;
  }
}
a.navbar-link{
  font-weight: 400 !important;
  i.fa{
    font-weight: 400 !important;
  }
}
.navbar-end{
  padding-right: 10px;
  a{
    font-weight: 400;
    color: #0a0a0a;
    transition: 0.5s;
    &:hover{
      opacity:0.5;
    }
  }
}
.navbar-dropdown{
  background-color: white;
  box-shadow: none;
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
  border-radius: 0;
  top: 80%;
  a.navbar-item{
    font-weight: 400 !important;
    text-transform: none;
  }
}
.is-active{
  &.navbar-menu{
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: white;
    .navbar-end{
      text-align: center;
      background-color: white;
      a{
        color: #0a0a0a;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/app/components/appNav.vue